import * as React from 'react';

type Props = {
  className?: string
}

export default ({ className }: Props) => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          className={className}
        >
          <path d="M4 32h26.667a1.334 1.334 0 000-2.667H4A1.335 1.335 0 012.667 28V1.333a1.334 1.334 0 00-2.667 0V28c0 2.206 1.794 4 4 4z"></path>
          <path d="M10 21.333a4.672 4.672 0 004.667-4.666c0-.954-.29-1.84-.782-2.58l4.277-5.132A4.644 4.644 0 0020 9.333c.22 0 .434-.02.647-.05l3.616 7.879a4.651 4.651 0 00-1.596 3.505 4.672 4.672 0 004.666 4.666A4.672 4.672 0 0032 20.667 4.672 4.672 0 0027.333 16c-.22 0-.434.02-.647.05l-3.615-7.878a4.651 4.651 0 001.596-3.505A4.672 4.672 0 0020 0a4.672 4.672 0 00-4.667 4.667c0 .953.289 1.84.781 2.58l-4.276 5.132A4.632 4.632 0 0010 12a4.672 4.672 0 00-4.667 4.667A4.672 4.672 0 0010 21.333zm19.333-.666c0 1.102-.897 2-2 2-1.102 0-2-.898-2-2 0-1.103.898-2 2-2 1.103 0 2 .897 2 2zM20 2.667c1.102 0 2 .897 2 2 0 1.102-.898 2-2 2-1.103 0-2-.898-2-2 0-1.103.897-2 2-2zm-10 12c1.102 0 2 .897 2 2 0 1.102-.898 2-2 2-1.103 0-2-.898-2-2 0-1.103.897-2 2-2z"></path>
        </svg>
    );
};
